import { DotsHorizontalIcon } from "@heroicons/react/solid";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import { React, useContext, useState } from "react";
import { Link } from "react-router-dom";
import ShowMoreText from "react-show-more-text";
import swal from "sweetalert";
import "../../components/CSS/Home/Post.css";
import "../../components/CSS/Sidebar/Left/Enroll.css";
import noImage from "../../Assets/Images/settings/no-image.png";
import PostReaction from "./PostReaction";
import { serverInfo } from "../../App";



export default function SingleFanGroup({ post }) {

  const { imageCdnUrl } = useContext(serverInfo);

  const [open, setOpen] = useState(false);
  const [data, setData] = useState({
    likes: post.react_number,
    updated: false,
  });

  const handleSubmit = (id) => {
    //e.preventDefault();
    if (!data.updated) {
      setData({ likes: data.likes + 1, updated: true });
    } else {
      setData({ likes: data.likes - 1, updated: false });
    }

    axios.get(`/api/submit_react/${id}`).then((res) => {
      if (res.data.status === 200) {
      } else {
        swal("Warning", "failed", "warning");
      }
    });
  };
  return (
    <>
      <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
        <div className="card PostCardBg ">
          <h2 className="accordion-header PostBack">
            <div className="d-flex justify-content-between">
              <div className="accordion-button-fx profile1-accordion-button PostBack  collapsed">
                <img
                  src={
                    post?.fangroup?.my_superstar?.image !== null
                      ? imageCdnUrl + post?.fangroup?.my_superstar?.image
                      : noImage
                  }
                  className="PostImgHome"
                  alt="star-profile"
                  title={
                    post.fangroup?.my_superstar?.first_name +
                    " " +
                    post.fangroup?.my_superstar?.last_name
                  }
                />

                <img
                  src={
                    post.fangroup?.another_superstar?.image !== null
                      ? imageCdnUrl + post.fangroup?.another_superstar?.image
                      : noImage
                  }
                  className="PostImgHome"
                  alt="star-profile"
                  title={
                    post.fangroup?.another_superstar?.first_name +
                    " " +
                    post.fangroup?.another_superstar?.last_name
                  }
                />

                <span className="mx-2 text-warning text-light">
                  <Link
                   to={{
                    pathname: `/group/${post.fangroup?.id}`,
                    state: { post: post },
                  }}
                    className="link-starPorfile"
                  >
                    {post?.title}
                  </Link>
                  <br></br>
                  <small className="category-size-chat">
                    {moment(post.fangroup?.start_date).format("LL")}
                    {" | "}
                  </small>
                  <small className="category-size-chat">
                    {moment(post.fangroup?.end_date).format("LL")}
                  </small>
                </span>
              </div>
            </div>
          </h2>

          <ShowMoreText
            lines={3}
            more={<span>See more</span>}
            less={<span>See less</span>}
            className="content-css my-2 Enroll-a Enroll-text py-2"
            anchorClass="my-anchor-css-class"
            //onClick={executeOnClick}
            expanded={false}
            truncatedEndingComponent={"... "}
          >
            <Markup content={post?.details}></Markup>
          </ShowMoreText>
          <center className="post_new">
            <img
              src={imageCdnUrl + post?.fangroup?.banner}
              alt={post.fangroup?.banner}
            />
          </center>
          <div className="ViewPost">
            <div className=" card  border-0 containerPost">
              <div className="centeredPost ">
                <div className="LeftTextPost col-md-8">
                  <div className=" text-light bottom-LeftPost text-start  fw-bold px-4 py-1">
                    Fan Group
                  </div>
                </div>

                <div className="LeftTextPost col-md-4">
                  <Link
                    to={{
                      pathname: `/group/${post.fangroup?.id}`,
                      state: { post: post },
                    }}
                    className="link-starPorfile"
                  >
                    {" "}
                    <button className="bottom-rightPost text-dark fw-bold AnimateBtn px-4 py-1">
                      <span className="pTd"> Explore Now</span>
                    </button>
                  </Link>
                </div>
              </div>
              <div className="centeredPostV "></div>
            </div>

            <PostReaction post={post}></PostReaction>
          </div>
        </div>
      </div>
    </>
  );
}
